import { GetMobilePhoneFromClaimResponseDto } from './../models/server-models/reseponse-dtos/get-mobile-phone-from-claim-response-dto';
import { CreateMobilePhoneClaimResponseDto } from './../models/server-models/reseponse-dtos/create-mobile-phone-claim-response-dto';
import { CreateMobilePhoneClaimRequestDto } from './../models/server-models/request-dtos/create-mobile-phone-claim-request-dto';
import { GetUserResponseDto } from './../models/server-models/reseponse-dtos/get-user-response-dto';
import { StartPrintUserDto } from './../models/server-models/entities/startprint-user-dto';
import { RegisterClientRequestDto } from './../models/server-models/request-dtos/register-client-request-dto';
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { map, Observable } from 'rxjs';
import { RegisterClientResponseDto } from '../models/server-models/reseponse-dtos/register-client-response-dto';
import { LoginClientRequestDto } from '../models/server-models/request-dtos/login-client-request-dto';
import { LoginClientResponseDto } from '../models/server-models/reseponse-dtos/login-client-response.dto';

@Injectable({ providedIn: 'root' })
export class AuthApiService {
  private httpClient = inject(HttpClient);

  registerClient(dto: RegisterClientRequestDto): Observable<RegisterClientResponseDto> {
    return this.httpClient.post<RegisterClientResponseDto>(environment.apiUrl + '/api/auth/register', dto);
  }

  loginClient(dto: LoginClientRequestDto): Observable<string> {
    return this.httpClient.post<LoginClientResponseDto>(environment.apiUrl + '/api/auth/login', dto).pipe(
      map((response: LoginClientResponseDto) => {
        return response.idToken;
      })
    );
  }

  handleSocialLogin(idToken: string): Observable<any> {
    return this.httpClient.post<any>(environment.apiUrl + '/api/auth/social-login', {
      idToken,
    });
  }

  getStartPrintUser(): Observable<StartPrintUserDto> {
    return this.httpClient
      .get<GetUserResponseDto>(environment.apiUrl + '/api/auth/user')
      .pipe(map((response) => response.user));
  }

  updateMobilePhone(dto: CreateMobilePhoneClaimRequestDto): Observable<CreateMobilePhoneClaimResponseDto> {
    return this.httpClient.post<CreateMobilePhoneClaimResponseDto>(environment.apiUrl + '/api/profile/mobile', dto);
  }

  getMobilePhone(): Observable<GetMobilePhoneFromClaimResponseDto> {
    return this.httpClient.get<GetMobilePhoneFromClaimResponseDto>(environment.apiUrl + '/api/profile/mobile');
  }

  deleteAccount(): Observable<any> {
    return this.httpClient.delete(environment.apiUrl + '/api/auth');
  }
}
